import HelpIcon from '@mui/icons-material/Help';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from '@mui/material';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  boldFont,
  strategicLabel,
  summaryAccordionIcon,
  SummaryAccordionStyle,
  TrackingDrivers,
  TrackingDriversLabel,
} from '../../styles';
import TripleToggleSwitch from '../atoms/triple-toggle-switch';

export function AccordionContainer({ children }) {
  const { t } = useTranslation();

  return (
    <Accordion sx={SummaryAccordionStyle} elevation={0}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon sx={summaryAccordionIcon} />}
        aria-controls="drivers-content"
        id="drivers-header"
      >
        <Grid style={boldFont}>{t('Drivers')}</Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {children}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
function TrackingFileDriver({ title, description, value }) {
  return (
    <Grid style={TrackingDrivers} container>
      <Grid style={TrackingDriversLabel} item xs={4}>
        {title}
        <Tooltip
          title={description}
          placement="top-start"
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '16px',
              },
            },
          }}
        >
          <HelpIcon
            sx={{
              fontSize: 17,
              position: 'relative',
              top: '5px',
              left: '15px',
            }}
          />
        </Tooltip>
      </Grid>
      <Grid item xs={3} style={strategicLabel}>
        <TripleToggleSwitch value={value} disabled={true} />
      </Grid>
    </Grid>
  );
}

function TrackingFileDrivers({ data }) {
  const { t } = useTranslation();
  return (
    <AccordionContainer>
      <Grid item xs={6}>
        <TrackingFileDriver
          title={t('Strategic')}
          description={t('strategic_driver_description')}
          value={data?.Strategic}
        />
        <TrackingFileDriver
          title={t('EHS_Impacted')}
          description={t('ehs_driver_description')}
          value={data?.Safety}
        />
        <TrackingFileDriver
          title={t('Regulatory_Issue')}
          description={t('regulatory_driver_description')}
          value={data?.Regulatory}
        />
        <TrackingFileDriver
          title={t('External_Customer_Impacted')}
          description={t('external_customer_driver_description')}
          value={data?.CustomerImpact}
        />

        <TrackingFileDriver
          title={t('Turnbacks_Associated')}
          description={t('turnbacks_driver_description')}
          value={data?.Turnback}
        />
      </Grid>
      <Grid item xs={6}>
        <TrackingFileDriver
          title={t('Warranty_Claims_Issued')}
          description={t('warranty_driver_description')}
          value={data?.Warranty}
        />
        <TrackingFileDriver
          title={t('Potential_Product_Stoppage')}
          description={t('potential_product_stoppage_driver_description')}
          value={data?.StopProduction}
        />
        <TrackingFileDriver
          title={t('Standardization')}
          description={t('standardization_driver_description')}
          value={data?.Standardization}
        />
        <TrackingFileDriver
          title={t('Cost_Reduction')}
          description={t('cost_reduction_driver_description')}
          value={data?.CostReduction}
        />
      </Grid>
    </AccordionContainer>
  );
}

AccordionContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TrackingFileDriver.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.bool,
};

TrackingFileDrivers.propTypes = {
  data: PropTypes.shape({
    Strategic: PropTypes.bool,
    Safety: PropTypes.bool,
    Regulatory: PropTypes.bool,
    CustomerImpact: PropTypes.bool,
    Turnback: PropTypes.bool,
    Warranty: PropTypes.bool,
    StopProduction: PropTypes.bool,
    Standardization: PropTypes.bool,
    CostReduction: PropTypes.bool,
  }).isRequired,
};

export default TrackingFileDrivers;
